import { createContext } from 'react';

const LocaleContext = createContext<string>('');

export default LocaleContext;
